import React, { HTMLAttributes } from "react";
import "./FooterSection.styl";

class FooterSection extends React.PureComponent {
  render() {
    return (
      <div className="footer-section">
        <span className="copyright">Powered by iAID Inc. 2019</span>
        <span className="disclaimer">
          AID-U is not regulatory approved (e.g. FDA) for clinical use
        </span>
      </div>
    );
  }
}

export default FooterSection;
